import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { SxProps, Theme } from '@mui/material';

interface ControlledButtonProps {
  id: string;
  label: string;
  className?: string;
  variant?: "text" | "outlined" | "contained";
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  type?: 'submit' | 'button';
  loading?: boolean;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  onClick?: () => void;
  startIcon?: any;
  endIcon?: any;
  sx?: SxProps<Theme>;
}

const WSButton: React.FC<ControlledButtonProps> = ({
  id,
  label,
  className,
  variant = "contained",
  size = "medium",
  disabled = false,
  type = "button",
  loading = false,
  onClick,
  color = "primary",
  startIcon,
  endIcon,
  sx = {},
}) => {
  return (
    <Button
      id={id}
      type={type}
      disabled={disabled || loading}
      className={className}
      startIcon={startIcon}
      endIcon={endIcon}
      size={size}
      variant={variant}
      color={color}
      onClick={onClick}
      sx={{
        textTransform: "none",
        fontWeight: 500,
        fontSize:
          size === "small"
            ? "0.75rem"
            : size === "medium"
            ? "0.875rem"
            : "1rem",
        minWidth: 120,
        borderRadius: 2,
        py: 1,
        ...sx,
      }}
    >
      {loading ? <CircularProgress size={20} color="inherit" /> : label}
    </Button>
  );
};

export default WSButton;